import {useState,useEffect} from "react";
import { Link } from "react-router-dom";
import CtntTop5InqApi from "Apis/CtntTop5InqApi";
import MgpStore from "Stores/Store";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import GameSvcCtntPstdLstInqApi from "Apis/GameSvcCtntLstInqApi";
import { Padding } from "@mui/icons-material";
import { isMobile } from "react-device-detect";

const GameCtntTop5LstUi = ({gameSvcCd,ctntCtgrCd,ctntCtgrCdName,LstType}:any) => {
    const [ctntCtxtState,setCtntCtxtState] = useState<any>();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    useEffect(()=>{
        switch (LstType){
            case "top5" :
                CtntTop5InqApi(gameSvcCd,ctntCtgrCdCd).then((resp)=> {
                    setCtntCtxtState(resp.apiBody.ctntLst);
                });
                break;
            case "Lst":
                GameSvcCtntPstdLstInqApi(gameSvcCd,ctntCtgrCdCd,"0",null,null).then((resp)=> {
                    setCtntCtxtState(resp.apiBody.ctntLst);
                })
                break;
            default:
                GameSvcCtntPstdLstInqApi(gameSvcCd,ctntCtgrCdCd,"0",null,null).then((resp)=> {
                    setCtntCtxtState(resp.apiBody.ctntLst);
                })
                break;
        }
      },[MgpStore.getState().LangSetState.Lang])
    const [ctntCtgrCdCd,setctntCtgrCdCd] = useState(ctntCtgrCd);
    return(
        <>
        <div className="ctntLstWrap">

            <div className="ctntLstTitlArea gamePagectntLstTitlArea">
                <div className={`${ctntCtgrCdCd}TitlWrap ctntLstTitlWrap mainPageCtntTitlWrap`}>
                    <p>NOTICE</p>
                    <Link to={`/GamePage/Ctnt/CtntLst?gameSvcCd=${gameSvcCd}&ctntKindCd=${ctntCtgrCdCd}`}>
                        <p>더 보기</p>
                    </Link>
                </div>
            </div>
            <div className="ctntLstContentsWrap">
                <ul>
                    {ctntCtxtState&&ctntCtxtState.map((key:any) => (
                        <li>
                            <Link to={`/GamePage/Ctnt/CtntCtxt?gameSvcCd=${key.gameSvcCd}&ctntKindCd=${ctntCtgrCdCd}&ctntSno=${key.ctntSno}`}>
                                <p className="ctntTitlTxt">{key.ctntTitl}</p>
                                <p className="ctntDate">{key.aplyStrtDtime}</p>
                            </Link>
                        </li>
                    ))} 
                </ul>
            </div>
        </div>
        </>
    )
}
export default GameCtntTop5LstUi;